import {type TranslationObject} from '@colonist/i18n'
import {ViewPopupDisableAdblockMain} from './ViewPopupDisableAdblockMain.ts'

export class ViewPopupHumorousDisableAdblock extends ViewPopupDisableAdblockMain {
    constructor(continuationAction: () => void, completionAction: () => void, isSoftPopup: boolean, canCancel: boolean) {
        const title: TranslationObject = {key: 'strings:popups.uhOh.title'}
        const softPopupBody: TranslationObject = {key: 'strings:popups.disableAdBlock.softPopupBody'}
        const hardPopupBody: TranslationObject = {key: 'strings:popups.disableAdBlock.hardPopupBody'}
        const body = isSoftPopup == true ? softPopupBody : hardPopupBody
        const continueText: TranslationObject = {key: 'strings:popups.disableAdBlock.continue'}
        const softPopupOptions = isSoftPopup == false ? undefined : {continuationText: continueText, continuationAction: continuationAction}
        super(title, body, canCancel, completionAction, softPopupOptions)
    }
}
